<template>
  <div>
    <b-card  class="applicant-wrapper" v-if="applicant">
      <template slot="header">
        <div class="header-caption">{{$t('APPLICANT')}}</div>
        <h3 class="applicant-wrapper-padding">{{applicant.first_name}} {{applicant.last_name}}</h3>
        <div class="d-flex">
          <div class="mr-auto">
            <b-badge class="ml-1" v-if="applicant.status && applicant.status.id" :variant="applicant.status.id === STATUS_COMPLETE ? 'success' :'danger'">
              {{applicant.status.name}}
            </b-badge>
            <span class="ml-2"  v-if="applicant.status && applicant.status.id === STATUS_COMPLETE">{{$t('PROCESS_DURATION')}}: <b>{{applicant.process_duration > 0 ? applicant.process_duration : 1}} {{durationTranslate}}</b></span></div>
          <div>
            <a v-if="applicant.status && applicant.status.id === STATUS_COMPLETE && activeDocumentSetup && activeDocumentSetup.id" @click="downloadPdf" class="hand-pointer mr-2">
              <pdf-icon />
            </a>

            <app-button @click="openCopyDialog = true" :loading="copy_loader"
                        v-if="visibleTemporaryDecision && applicant.hasOwnProperty('decision_type') &&  Number(applicant.decision_type) === TEMPORARY_DECISION && applicant.status.hasOwnProperty('id') &&  applicant.status.id === STATUS_COMPLETE"
                        variant="danger" class="pull-right ml-2">
              {{ $t('MAKE_PERMANENT_SOLUTION') }}
            </app-button>

            <app-button v-if="0" :loading="pdf_loader" :disabled="disabledGenerateDecision" @click="fetchPdfDecision"
                        :c_permission="C_GENERATE_DECISION" class="mr-3 ml-3">
              {{ $t('GENERATE_DECISION') }}
            </app-button>


            <app-button v-if="applicant.status && applicant.status.id !== STATUS_ARCHIVED" @click="changeStatus()"
                        :c_permission="C_STATUS" :loading="loader_change_status">
              {{ applicant.status.id === STATUS_IN_PROCESS ? $t('RECOGNITION_COMPLETE_TEXT') : $t('STATUS_PROCESS_TEXT') }}
            </app-button>
          </div>
        </div>
        <applicant-navigation>

        </applicant-navigation>

      </template>

        <page-transition transition-type="slide">
          <router-view v-cloak></router-view>
        </page-transition>

      <b-modal style="overflow-y: auto;" v-model="openCopyDialog" no-close-on-esc no-close-on-backdrop hide-header-close>
        <div  slot="modal-header">
          <h5>    Permanent decision</h5>

        </div>
        <slot><span class=" mb-5">  Are you want to make new permanent decision, then this decision move to archive?</span></slot>
        <div slot="modal-footer">
          <app-button @click="copy" :loading="copy_loader" variant="danger">
            {{$t('CONFIRM')}}
          </app-button>

          <b-button variant="link" @click="openCopyDialog = false">{{$t('CANCEL')}}</b-button>
        </div>
      </b-modal>
    </b-card>

  </div>

</template>

<script>
  import loading from 'vue-full-loading'
  import PageTransition from '@/components/app/transition/AppTransition'
  import ApplicantNavigation from '@/components/applicant/navigation/Index'
  import AppButton from "@/components/app/AppButton";
  import {generatePdfDecision, getApplicant, changeApplicantStatus} from "@/services/applicant";
  import {
    STATUS_IN_PROCESS,
    STATUS_COMPLETE,
    TEMPORARY_DECISION,
    STATUS_ARCHIVED,
    ECONOMY_BIH, USER_DATA
  } from "@/shared/constants"
  import {toast} from '@/shared/plugins/toastr'
  import {C_GENERATE_DECISION, C_STATUS} from '@/shared/component_permission'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import {copyRecognitionData, downloadPdfRecognitionDecision} from "@/services/recognition";
  import routeNames from "@/router/routeNames";
  import PdfIcon from "@/components/icons/PdfIcon";
    export default {
        name: "Index",
      data(){
          return {
            STATUS_ARCHIVED,
            pdf_loader:false,
            STATUS_IN_PROCESS,
            STATUS_COMPLETE,
            TEMPORARY_DECISION,
            C_GENERATE_DECISION,
            C_STATUS,
            loader_change_status:false,
            copy_loader:false,
            openCopyDialog:false,
          }
      },
      mixins:[getErrorMessage],
      components:{
        PdfIcon,
        AppButton,
        ApplicantNavigation,
        PageTransition,
        loading
      },
      computed:{
        classValue(){
          return this.loading ?  'fa fa-spinner fa-spin fa-fw' : ''
        },
        user(){
          return JSON.parse(localStorage.getItem(USER_DATA))
        },
        visibleTemporaryDecision(){
           return Number(this.user.economy.id) === ECONOMY_BIH
        },
        durationTranslate(){
          if(this.applicant.process_duration === 0){
            return this.$t('DAY')
          }
          if(this.applicant.process_duration === 1){
            return this.$t('DAY')
          } else {
            return this.$t('DAYS')
          }
        },
        applicant(){
          return this.$store.getters['applicant/getApplicant']
        },
        activeDocumentSetup() {
          return this.$store.getters['applicant/activeDocumentSetup'];
        },
        disabledGenerateDecision(){
          return this.applicant.status && this.applicant.status.id === STATUS_COMPLETE ? false : true
        }
      },
      methods:{
        downloadPdf() {
          downloadPdfRecognitionDecision(this.activeDocumentSetup.id).then((response) => {
            let blob = new Blob([response], {type: 'application/pdf'});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`${this.applicant.first_name}${this.applicant.last_name}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
        },
          copy(){
            this.copy_loader = true
            copyRecognitionData(this.applicant.id).then(response =>{
              toast({
                'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'message': null,
                'type': 'success',
                'timeout': 5000
              })
              this.copy_loader = false
              setTimeout(()=>{
                this.openCopyDialog = false
                this.$router.push({name: routeNames.RN_APPLICANT_BASIC, params: {id: response.data}})
              },100)

            }, error =>{
              toast({
                'message': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE',{value:this.getMessages(error)}),
                'type': 'error',
                'timeout': 6000
              })
            }).finally(()=>{
                this.copy_loader = false

            })
          },
        fetchApplicant(id){
          this.$store.dispatch('applicant/actionSetApplicant', id)
        },
        changeStatus() {
          this.loader_change_status= true
          let requestObject = {
             status: this.applicant.status && this.applicant.status.id === STATUS_IN_PROCESS ? STATUS_COMPLETE : STATUS_IN_PROCESS
          }
             changeApplicantStatus(this.$route.params.id,requestObject).then(response => {
                toast({
                    'message': this.$t('STATUS_CHANGE_SUCCESS'),
                    'type': 'success',
                    'timeout': 5000
                })
                  this.fetchApplicant(this.$route.params.id)
                }, error => {
              for(let el of error.response.data.error_list){
                 if(el.code === 4001 || el.code === 4022){
                   toast({
                     'message': this.$t('COMPLETE_STATUS_ERR_MESSAGE'),
                     'type': 'error',
                     'timeout': 6000
                   })
                   break;

                 } else if(el.code === 8002) {
                   toast({
                     'message': this.$t('COMPLETE_STATUS_DDS_ERR_MESSAGE'),
                     'type': 'error',
                     'timeout': 6000
                   })
                   break;
                 } else {
                   toast({
                     'message': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE',{value:this.getMessages(error)}),
                     'type': 'error',
                     'timeout': 6000
                   })
                 }
               }

            }).finally(()=>{
              this.loader_change_status = false
             })
        },
        fetchPdfDecision(){
          this.pdf_loader = true
          generatePdfDecision(this.$route.params.id).then(response => {

          }).finally(()=>{
            this.pdf_loader = false
          })
        }
      },
      watch:{
          '$route.params.id':{
           async handler(value){
             if(!value) return;
             await this.fetchApplicant(value)
            },immediate:true
          }
      },
      beforeDestroy() {
        this.$store.dispatch('applicant/actionResetAplicant')
      }
    }

</script>

<style>
.hand-pointer {
  cursor: pointer;
}
</style>
